import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { composeWithDevTools } from "@redux-devtools/extension";

import megazoneCloudMediaApp from "./reducers";

const useDevTools = process.env.REACT_APP_NOT_SECRET_CODE &&
    (process.env.REACT_APP_NOT_SECRET_CODE.trim() === "development" ||
        process.env.REACT_APP_NOT_SECRET_CODE.trim().indexOf("local") >= 0 ||
        process.env.REACT_APP_NOT_SECRET_CODE.trim() === "qa");

let middleware;
if(useDevTools) {
    console.log(`### Redux DevTools activated ###`);
    const composeEnhancers = composeWithDevTools({trace: true, traceLimit: 25});
    middleware = composeEnhancers(applyMiddleware(thunk));
}
else {
    middleware = applyMiddleware(thunk);
}

const store = createStore(megazoneCloudMediaApp, middleware);

export default store;
